import React, { useState , useEffect} from 'react';

import { makeStyles } from '@mui/styles';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLongArrowLeft as leftArrow} from "@fortawesome/pro-regular-svg-icons";
import { faUserCircle as user} from "@fortawesome/pro-regular-svg-icons";

import {  useNavigate } from 'react-router-dom';

import LoadingButton from '@mui/lab/LoadingButton';

import {getConfigValue} from './Config';



const useStyles = makeStyles(theme => ({   
    header: {
        fontFamily:'Mulish', 
        fontWeight: '200',
        width:'100%',
        height:'3em',        
        backgroundColor: '#202146',
        color: 'white',

        display:'flex',
        justifyContent:'flex-start',
        alignItems:'center',
        flexShrink:0,
        fontWeight: 'bold',
        
    }, 
    arrow:  {
        fontSize: '2em',
        
        display: 'flex', 
        flexDirection: 'row', 
        justifyContent: 'center',
        justifySelf: 'flex-start',

        width: '40px',
        paddingLeft: '.5em',
        
    },
    title: {
        fontFamily:'Mulish', 
        display: 'flex', 
        flexDirection: 'row', 
        width:'60%',
        justifyContent: 'center', 
        marginLeft: '20%',
        
    }, 
    userBox: {
        fontSize: 12,
        display: 'flex', 
        width: '400px',
        flexDirection: 'row',         
        justifyContent: 'flex-end', 
        justifySelf: 'flex-end',
        marginRight: '.5em',   
    }

    }));




const AppHeader = (props) => {
    const classes = useStyles();
    const history = useNavigate();
    const navigate = useNavigate();

    const [loadingButtons, setLoadingButtons] = useState({});

    const [userName, setUserName] = useState('');

    var store = require('store')

    useEffect(() =>  { 
        if (props.userName)
            setUserName(props.userName);
        
    },[props.userName])

    const isLoading = (buttonName) => {
        return loadingButtons[buttonName];
    }

    const setLoading =(buttonName, isLoading) => {
        var ldnButtons = {...loadingButtons};
        ldnButtons[buttonName] = isLoading;
        setLoadingButtons(ldnButtons);        
    }

    const logOut = async () => {
        setLoading("logout", true)        

        const res = await fetch(`${getConfigValue('serverBaseUrl')}/api/Home/logOut/${store.get("sessionToken")}`);            
        const json = await res.json();            

        setUserName('');

        setLoading("logout", false)

        if (props.setLoggedIn)
            props.setLoggedIn(false);

      }

    return(              
        <div className={classes.header} style={{ backgroundColor: props.admin == undefined? '#202146': '#FFCB66'}}>         
             <div className={classes.arrow} >
               {props.backButton==true && <FontAwesomeIcon icon={leftArrow} onClick={_=>history.goBack()} /> }
            </div>   
            
            <div className={classes.title}>
                {props.title} 
                <div style={{fontSize:9}}>&nbsp; v1.0.4</div>
            </div>

            {props.isLoggedIn &&
                <div className={classes.userBox}>
                    <div><FontAwesomeIcon icon={user } />
                    &nbsp;
                    {userName}
                    &nbsp;
                    <LoadingButton onClick={_=>logOut()} loading={isLoading("logout")}variant="contained" size='small' color="secondary" >Logg Ut </LoadingButton>
                    </div>
                </div>
            }
        </div>     
    )
};

export default AppHeader;